/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

/*
 *   Handle Error Boundary for all pages
 */
const { isAfter } = require('date-fns');
const { zonedTimeToUtc } = require('date-fns-tz');
const React = require('react');
const ErrorBoundary = require('./src/components/Common/ErrorBoundary').default;
const { ScriptLoader, UtmTracker } = require('@kindur/components');

const DELAYED_SCRIPTS = [
  {
    snippetId: 'fullstory',
    delay: 500,
    waitForUserInteraction: false,
    text: `
      window['_fs_debug'] = false;
      window['_fs_host'] = 'fullstory.com';
      window['_fs_script'] = 'fullstory.com/s/fs.js';
      window['_fs_org'] = 'HZ7GM';
      window['_fs_namespace'] = 'FS';
      (function(m,n,e,t,l,o,g,y){
          if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
          g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
          o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
          y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
          g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
          g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
          g.log = function(a,b) { g("log", [a,b]) };
          g.consent=function(a){g("consent",!arguments.length||a)};
          g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
          g.clearUserCookie=function(){};
      })(window,document,window['_fs_namespace'],'script','user');
    `
  },
  {
    snippetId: 'ze-snippet',
    delay: 4000,
    waitForUserInteraction: true,
    url: 'https://static.zdassets.com/ekr/snippet.js?key=abebc42f-8e3b-4fe0-9508-99a2395e95b0'
  }
];

function getUTCDate(date = new Date()) {
  return zonedTimeToUtc(date, 'America/New_York');
}

function getDateFromQuerystring () {
  let currentDate = getUTCDate();
  let values;
  try {
    const query = (new URLSearchParams(document.location.search)).get('date');
    if (query) {
      values = query.split('-').map(Number);
      if (values.length > 1) {
        values[1] -= 1; // JS months are -1
      }
      // @ts-ignore
      currentDate = getUTCDate(new Date(...values));
    }
  } catch (e) {
    console.error('>>> Date comparison error', e);
  }
  return currentDate;
}

function isAfterNov27 () {
  // @ts-ignore
  const testDate = getUTCDate(new Date(...[2019, 10, 27, 15, 0])); // Wed, Nov 27, 3pm EST
  const currentDate = getDateFromQuerystring() || getUTCDate();
  return isAfter(currentDate, testDate);
}

function isAfterDecember3 () {
  // @ts-ignore
  const testDate = getUTCDate(new Date(...[2019, 11, 3, 3, 0])); // Tue, Dec 3, 3am EST
  const currentDate = getDateFromQuerystring() || getUTCDate();
  return isAfter(currentDate, testDate);
}

exports.onInitialClientRender = () => {
  // eslint-disable-next-line no-restricted-globals
  const { document, location } = window;

  // Throw a test error?
  if (location.search.includes('?throw-test-error')) {
    setTimeout(() => {
      throw new Error(`IGNORE TEST ERROR: ${location.search.split('?throw-test-error=').pop()}`);
    }, 3000);
  }

  // Date-related CSS
  document.body.classList.add(`is-${isAfterNov27() ? 'after' : 'before'}-nov27`);
  document.body.classList.add(`is-${isAfterDecember3() ? 'after' : 'before'}-dec3`);
  if (isAfterNov27() && isAfterDecember3()) {
    document.body.classList.add('is-between-dates');
  }
  if (!isAfterNov27() && !isAfterDecember3()) {
    document.body.classList.add('is-outside-dates');
  }
};

exports.onRouteUpdate = () => {
  window.analytics && window.analytics.page(window.testEventProps);
};

exports.wrapPageElement = ({ element, props }) => {
  return (
    <ErrorBoundary {...props}>
      {DELAYED_SCRIPTS.map((props, i) => (
        <ScriptLoader key={`script-loader-${i}`} {...props} />
      ))}
      <UtmTracker location={window.location}>{element}</UtmTracker>
    </ErrorBoundary>
  );
};
